/**
 * Events loader — single source of truth for the public site.
 *
 * Tries the live API first (so admin edits are reflected immediately).
 * Falls back to the bundled static file when the API isn't reachable
 * (e.g. dev without `yarn server` running, or backend temporarily down).
 *
 * Set REACT_APP_EVENTS_URL=/api/events in .env / .env.production so the
 * live site always asks the backend. The static fallback at
 * /assets/eventos.json is only there for resilience and dev convenience.
 */

const API_BASE  = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');
const PRIMARY   = process.env.REACT_APP_EVENTS_URL || `${API_BASE}/api/events`;
const FALLBACK  = '/assets/eventos.json';

function bust(url) {
  const sep = url.includes('?') ? '&' : '?';
  return `${url}${sep}v=${Date.now()}`;
}

function isValidCollection(data) {
  return data && data.type === 'FeatureCollection' && Array.isArray(data.features);
}

/** Returns the FeatureCollection or null if every source fails. */
export async function loadEvents() {
  const tried = new Set();
  const urls = [PRIMARY, FALLBACK].filter(u => {
    if (!u || tried.has(u)) return false;
    tried.add(u);
    return true;
  });

  for (const url of urls) {
    try {
      const r = await fetch(bust(url), { cache: 'no-store' });
      if (!r.ok) continue;
      const data = await r.json();
      if (isValidCollection(data)) return data;
    } catch (e) { /* try next */ }
  }
  return null;
}
